import { FormattedMessage } from 'react-intl';

import { StyledBackground, StyledImage } from './Error500Page.styled';

const Error500Page: React.FC = () => {
  return (
    <StyledBackground>
      <h1>500</h1>
      <p>
        <FormattedMessage
          id="page.500.text"
          defaultMessage="Our apologies - we're experiencing technical difficulties at this time.<br/> Please try again later."
        />
      </p>
      <StyledImage src="/images/icons/500-image.svg" />
    </StyledBackground>
  );
};

export default Error500Page;
